import { UpcomingMatchesSchema } from '@/views/sports/UpcomingMatches/styles/UpcomingMatches.styles';

export const upcomingMatchesStyles: UpcomingMatchesSchema = {
  pageHeader: {
    fontSize: 'xl',
    fontWeight: 'normal',
    fontFamily: 'SkranjiBold',
    textTransform: 'uppercase',
  },
  stackWrapper: {
    color: 'white',
    mt: ['-1', null, '0', '-2'],
    px: ['2', null, null, '4'],
    py: '2',
  },
  boxWrapper: {
    alignItems: 'center',
    display: [null, null, null, 'flex'],
    justifyContent: 'space-between',
  },
  sortByText: {
    fontSize: '2xs',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  scrollButtonGroup: {
    variant: 'filter',
    bg: 'none',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderColor: 'blackAlpha.400',
    borderRadius: 'none',
    boxShadow: '0 1px rgba(255, 255, 255, .07)',
    pb: '2',
  },
  flexRenderSortingMobile: {
    justify: 'flex-end',
  },
  loadingSkeletonText: {
    my: '4',
    noOfLines: 2,
    spacing: '4',
    skeletonHeight: '2',
  },
  mainStackWrapper: {
    spacing: '4',
  },
  mainStackInner: {
    spacing: '4',
  },
  heading: {
    alignItems: 'center',
    display: 'flex',
    gap: '1',
    fontSize: 'xl',
    fontFamily: 'SkranjiRegular',
    color: 'white',
    fontWeight: 'normal',
    textTransform: 'uppercase',
  },
  headingIcon: {
    color: 'beta.200',
    sx: {},
  },
  boxSportWrapper: {
    borderColor: 'beta.500',
    borderWidth: '1px',
  },
  propositionButton: {
    flex: '1',
    height: '38px',
    display: 'initial',
  },
  buttonAllSports: {
    borderColor: 'beta.500',
    color: 'white',
    _active: {
      bg: 'beta.500',
      borderColor: 'beta.500',
      color: 'alpha.600',
      '&:after': {
        display: 'none',
      },
    },
  },
  buttonSport: {
    borderColor: 'beta.500',
    color: 'white',
    _active: {
      bg: 'beta.500',
      borderColor: 'beta.500',
      color: 'alpha.600',
      '&:after': {
        display: 'none',
      },
    },
    _hover: {
      color: 'beta.500',
    },
  },
};
